module.exports = __webpack_public_path__ + "img/23_109.f39fa019.png";